/**
 * 获取url中指定参数的值
 * @param name 需要获取的参数名
 * @param url 需要被处理的url，默认为当前url
 * @return 对应的参数值
 */
export function getUrlParam(name: string, url?: string): string {
  const paramReg = new RegExp(`[\\?&#]${name}=([^&#]+)`, 'gi')
  const paramMatch = (url || window.location.href).match(paramReg)
  let paramResult = []
  if (paramMatch && paramMatch.length > 0) {
    paramResult = paramMatch[paramMatch.length - 1].split('=')
    if (paramResult && paramResult.length > 1) {
      return paramResult[1]
    }
    return ''
  }
  return ''
}

export function getUrlParamReturnUndefined(name: string, url?: string) {
  const result = getUrlParam(name, url)
  return result ? result : undefined
}

export function getQuery<T extends Record<string, any>>(url?: string) {
  const queryStr = decodeURIComponent(url ?? location.href).replace(/.*\?/, '')
  return queryStr
    .split('&')
    .map((str) => str.split('='))
    .reduce((acc, [k, v]) => {
      acc[k] = v
      return acc
    }, {} as any) as T
}

/**
 * 删除url上的query参数
 * @param param 需要删除的key
 */
export function deleteUrlQuery(param: string) {
  try {
    const url = new URL(window.location.href)
    url.searchParams.delete(param)
    history.replaceState(null, null, url)
  } catch (error) {}
}

export function stringifyQuery(url: string, query: Record<string, string>) {
  return (
    url +
    '?' +
    Object.keys(query)
      .map((key) => `${key}=${query[key]}`)
      .join('&')
  )
}

export const formmatQueryObjectToString = (data?: Record<string, any>) => {
  if (!data) return ''
  const pairStr = Object.keys(data).reduce((acc, key) => {
    return acc.concat(`${key}=${data[key]}`)
  }, [] as string[])

  return pairStr.length ? `?${pairStr.join('&')}` : ''
}
